<template>
    <div>
        <b-tab title="Tab 4">
            <b-card-text>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-4">
                        <label>Tipologia del rischio:<br> Caduta dall'alto</label>
                    </div>
                    <div class="form-group col-md-4">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Presente</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="rischi.caduta_presente"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="rischi.caduta_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-4">
                        <label>Tipologia del rischio:<br>Caduta oggetti dall'alto</label>
                    </div>
                    <div class="form-group col-md-4">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Presente</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="rischi.caduta_oggetti_presente"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="rischi.caduta_oggetti_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-4">
                        <label>Tipologia del rischio:<br>Scivolamento a livello</label>
                    </div>
                    <div class="form-group col-md-4">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Presente</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="rischi.scivolamento_presente"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="rischi.scivolamento_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-4">
                        <label>Tipologia del rischio:<br>Elettrocuzione</label>
                    </div>
                    <div class="form-group col-md-4">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Presente</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="rischi.elettrocuzione_presente"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="rischi.elettrocuzione_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-4">
                        <label>Tipologia del rischio:<br>Tagli e abrasioni</label>
                    </div>
                    <div class="form-group col-md-4">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Presente</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="rischi.tagli_abrasioni_presente"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="rischi.tagli_abrasioni_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-4">
                        <label>Tipologia del rischio:<br>Meccanico</label>
                    </div>
                    <div class="form-group col-md-4">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Presente</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="rischi.meccanico_presente"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="rischi.meccanico_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
            </b-card-text>
        </b-tab>
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva</button> -->
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva</button>
        <router-link :to="'valutazione-a?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
        <router-link to="/clienti" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link> -->
        
    </div>
</template>
<script>
import Services from '@/services/Services';

export default {
    components: {},

    data() {
        return {
            rischi: {},
            
            idCliente: null,
            idSoggetto: null,
        }
    },

    props: {
        rischiValori: {
            type: Object,
            required: true
        }
    },
    computed: {},

    methods: {
        addRischiValori() {
            this.rischi = Object.assign({}, this.rischiValori);
        },

    },
    created() {
        this.addRischiValori();
    },
    
    // mounted() {
    //     this.main();
    // } 

};
</script>
<style scoped>
    .row-color:hover {
    background-color: #00467f53;
    }
    label {
        font-size: 16px;
    }

    .label-switch {
            position: relative;
        /* display: inline-block; */
        display: table-cell;
        padding-right: 10px;
        padding-left: 10px;
        font-size: 16px;
    }
    .switch {
        position: relative;
        /* display: inline-block; */
        display: table-cell;
        width: 55px;
        height: 34px;
    }

    .switch input { 
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

        .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 0px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    input:checked + .slider {
        background-color: #00467f;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #00467f;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }
    .slider.round:before {
        border-radius: 50%;
    }
</style>
